import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Scrolls to the element matching the URL hash, or to the top on a plain route change. */
export function useHashScroll() {
  const { hash, pathname } = useLocation()

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0)
      return
    }
    const id = window.setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 40)
    return () => window.clearTimeout(id)
  }, [hash, pathname])
}
